import { CSSProperties } from 'react'

export const getMenuStyles = (
  menuRect: DOMRect,
  buttonRect: DOMRect,
  containerRect: DOMRect,
  positionStrategy: 'fixed' | 'absolute',
  offset?: [number, number],
  renderInPortal?: boolean
) => {
  const offsetX = offset?.at(0) ?? 0
  const offsetY = offset?.at(1) ?? 0

  const totalHeight = containerRect.height
  const totalWidth = containerRect.width
  const containerOffsetTop = containerRect.top
  const containerOffsetLeft = containerRect.left
  const shadowOffset = 2

  const doesFitBottom = totalHeight > buttonRect.bottom + menuRect.height + offsetY - containerOffsetTop
  const doesFitTop = containerOffsetTop < buttonRect.top - menuRect.height - offsetY - shadowOffset
  const doesFitRight = totalWidth > buttonRect.left + menuRect.width + offsetX - containerOffsetLeft

  let styles: CSSProperties = {}

  if (renderInPortal) {
    const top = buttonRect.top - menuRect.height + offsetY
    const left = buttonRect.right - menuRect.width + offsetX
    styles.left = left > 0 ? left : 0
    styles.top = top > 0 ? top : 0
  } else if (positionStrategy === 'fixed') {
    // Set x value
    if (!doesFitRight) {
      styles.left = buttonRect.right - menuRect.width - offsetX - shadowOffset - containerOffsetLeft
    } else {
      styles.left = buttonRect.left + shadowOffset + offsetX - containerOffsetLeft
    }
    // set y value
    if (!doesFitBottom && !doesFitTop) {
      styles.top = 0
    } else if (!doesFitBottom) {
      styles.top = buttonRect.top - menuRect.height - shadowOffset - offsetY - Math.abs(containerOffsetTop)
    } else {
      styles.top = shadowOffset + buttonRect.bottom + offsetY - containerOffsetTop
    }
    styles = { ...styles, position: positionStrategy }
  } else {
    // Set x value
    if (!doesFitRight) {
      styles.right = offsetX + shadowOffset
    } else {
      styles.left = shadowOffset + offsetX
    }

    // set y value
    if (!doesFitBottom && !doesFitTop) {
      styles.bottom = 0
    } else if (!doesFitBottom) {
      styles.bottom = buttonRect.height + shadowOffset + offsetY
    } else {
      styles.top = shadowOffset + buttonRect.height + offsetY
    }
  }
  styles = { ...styles, opacity: 1 }

  return styles
}

export const getScrollParents = (node: HTMLElement | null, scrollParents: HTMLElement[] = []): HTMLElement[] => {
  if (node == null) {
    return scrollParents
  }
  if (scrollParents.length > 4) {
    return scrollParents
  }

  if (node.scrollHeight > node.clientHeight) {
    return getScrollParents(node.parentNode as HTMLElement, scrollParents.concat(node))
  } else {
    return getScrollParents(node.parentNode as HTMLElement, scrollParents)
  }
}

export const getContainerEl = (containerId?: string) => {
  if (containerId) {
    return document.getElementById(containerId) ?? document.body
  }
  return document.querySelector('[data-layout-card]') ?? document.body
}
